import { Component, effect, input, Input, OnInit } from '@angular/core';
import { Car } from '../../models/car-model';
import { Plans } from '../../shared/constants/plan.constants';
import { Statuses } from '../../shared/constants/status.constants';
import { TranslateService } from '@ngx-translate/core';
import { RealEstate } from '../../models/real-estate.model';

@Component({
  selector: 'app-seller-details',
  standalone: false,
  templateUrl: './seller-details.component.html',
  styleUrl: './seller-details.component.scss',
})
export class SellerDetailsComponent {
  ad = input<Car | RealEstate>();

  plans = Plans;
  statuses = Statuses;

  constructor(private readonly translate: TranslateService) {}

  openWhatsApp(phoneNumber: string | undefined): void {
    if (!phoneNumber) {
      return; // or handle error / show message
    }

    // Remove spaces, dashes, etc.
    let normalized = phoneNumber.replace(/\D/g, '');

    // If number starts with 0, remove it
    if (normalized.startsWith('00')) {
      normalized = normalized.substring(2);
    }

    // Add the link of the current page
    const message = `${this.translate.instant('WHATSAPP_MESSAGE')} ${window.location.href}`;

    const encodedMessage = encodeURIComponent(message);

    const url = `https://wa.me/${normalized}?text=${encodedMessage}`;

    window.open(url, '_blank');
  }
}
